"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _vuex = require("vuex");
var _exportCostSlipUpload = require("@/api/exportCostSlipUpload/exportCostSlipUpload");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: "invoiceApplyDlg",
  props: {
    formDialog: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    companyName: {
      type: String,
      default: ""
    },
    idBlNos: {
      type: String,
      default: ""
    },
    invoiceData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      form: {
        invoiceNo: "",
        currency: "03",
        amountICNY: "",
        amountIUSD: "",
        amountIORMB: "",
        amountIDistinction1: "",
        amountIDistinction2: "",
        amountIDistinction3: "",
        invoiceWay: "02",
        soaNo: "",
        invoiceNumber: "",
        invoiceBlNoFeeId: ""
      }
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language'])),
  methods: {
    handleSave: function handleSave() {
      var _this = this;
      (0, _exportCostSlipUpload.invoicingApplicationSave)(this.form).then(function (res) {
        console.log(res);
        if (res.success) {
          _this.$message.success(_this.$t('exportCostSlipUpload.saveSuccessfully'));
          _this.closed();
        } else {
          _this.$message.warning(res.errorMessages[0]);
        }
      });
    },
    opened: function opened() {
      var _this2 = this;
      this.$nextTick(function () {
        _this2.form.amountIDistinction1 = _this2.formDialog.amountRMB;
        _this2.form.amountIDistinction2 = _this2.formDialog.amountUSD;
        _this2.form.amountIDistinction3 = _this2.formDialog.amountHKD;
        _this2.form.amountICNY = _this2.formDialog.amountAllRMB;
        _this2.form.amountIUSD = _this2.formDialog.amountAllUSD;
        _this2.form.amountIORMB = _this2.formDialog.amountRMB;
        _this2.form.invoiceBlNoFeeId = _this2.idBlNos;
        if (Object.keys(_this2.invoiceData).length === 0) {
          _this2.form.invoiceNo = _this2.companyName;
        } else {
          _this2.form.invoiceNo = _this2.invoiceData.invoiceNo;
          _this2.form.soaNo = _this2.invoiceData.soaNo;
          _this2.form.invoiceNumber = _this2.invoiceData.invoiceNumber;
          // if (this.invoiceData.paymentWayI=="05"){
          //
          // }else if(this.invoiceData.paymentWayI=="06"){
          //
          // }else if(this.invoiceData.paymentWayI=="07"){
          //
          // }
        }
        if (_this2.formDialog.amountAllRMB == null || _this2.formDialog.amountAllRMB == "0" || _this2.formDialog.amountAllUSD == null || _this2.formDialog.amountAllUSD == "0" || _this2.formDialog.amountAllHKD == null || _this2.formDialog.amountAllHKD == "0") {
          // this.paymentWayDisabled = true;
          _this2.$alert(_this2.$t('exportCostSlipUpload.noRate'), {
            confirmButtonText: _this2.$t('exportCostSlipUpload.confirm')
          });
        }
      });
    },
    closed: function closed() {
      this.$emit('handleCloseInvoiceApplyDlg');
    }
  }
};